import {useParams} from 'react-router-dom';

import {Grid, Stack} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
    TabComponentTab
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCustomer} from '../hooks/useCustomer.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {FormDrawer} from '../drawers/FormDrawer';

import {IndexPage as BankAccountsPage} from '../../bank-accounts/pages/IndexPage.tsx'
import {IndexPage as CardsPage} from '../../cards/pages/IndexPage.tsx'
import {RecordsTable as InvoicesTable} from '../../invoices/tables/RecordsTable.tsx'
import {RecordsTable as PaymentMethodsTable} from '../../payment-methods/tables/RecordsTable.tsx'
import {RecordsTable as SubscriptionsTable} from '../../subscriptions/tables/RecordsTable.tsx'
import {RecordsTable as PaymentIntentsTable} from '../../payment-intents/tables/RecordsTable.tsx'
import {RecordsTable as SetupIntentsTable} from '../../setup-intents/tables/RecordsTable.tsx'


export const EditPage = () => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {
        record: customer,
        loading,
        updateRecord,
    } = useCustomer(customerId);

    const {
        drawerOpened,
        setDrawerOpened,
        tools,
    } = useEditPageTools();

    if (loading || !customer) {
        return <PlatformLoader message='Loading customer...Please wait'/>;
    }

    const tabs = [
        {
            title: 'Subscriptions',
            component: <SubscriptionsTable customerId={customerId}/>
        },
        {
            title: 'Invoices',
            component: <InvoicesTable customerId={customerId}/>
        },
        {
            title: 'Payment Methods',
            component: <PaymentMethodsTable customerId={customerId}/>
        },
        {
            title: 'Cards',
            component: <CardsPage/>
        },
        {
            title: 'Bank Accounts',
            component: <BankAccountsPage/>
        },
    ] as TabComponentTab[]

    const activityTabs = [
        {
            title: 'Payment Intents',
            component: <PaymentIntentsTable customerId={customerId}/>
        },
        {
            title: 'Setup Intents',
            component: <SetupIntentsTable customerId={customerId}/>
        },
    ] as TabComponentTab[]


    return (
        <FormPageLayout
            title={customer.name ? customer.name : customer.id}
            pageNavigation={<EditPageNavigation component={customer}/>}
            tools={tools}
        >

            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 4
                }}>
                    <Profile record={customer}/>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    lg: 8
                }}>
                    <Stack gap="xl">
                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={tabs}/>
                        </SimplePageContentWrapper>

                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={activityTabs}/>
                        </SimplePageContentWrapper>
                    </Stack>
                </Grid.Col>
            </Grid>

            <FormDrawer
                record={customer}
                handleSubmit={updateRecord}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />

        </FormPageLayout>
    );
};
